export default __webpack_public_path__ + "static/media/cw-3.17408b2a.png";